import { Button, ActionIcon, Tooltip } from "@mantine/core";
import { Save } from "lucide-react";

interface SavePlaygroundDataButtonProps {
    onClick: () => void;
}

export function SavePlaygroundDataButton({ onClick }: SavePlaygroundDataButtonProps) {
    return (
        <>
            <Tooltip label="Save Data">
                <ActionIcon
                    variant="light"
                    color="gray"
                    size="lg"
                    onClick={onClick}
                    hiddenFrom="sm"
                >
                    <Save size={18} />
                </ActionIcon>
            </Tooltip>
            <Button
                variant="light"
                color="gray"
                leftSection={<Save size={16} />}
                onClick={onClick}
                visibleFrom="sm"
            >
                Save Data
            </Button>
        </>
    );
}
